import React from "react";
import OtpInput from "react-otp-input";
import type { InputProps } from "@chakra-ui/react";
import { Input } from "@chakra-ui/react";

import type { JSX } from "react/jsx-runtime";
import { colors } from "../../../theme/colors";

interface TokenFieldProps {
	isDisabledSend: boolean;
	token: string;
	tokenError: { errorStatus: boolean };
	sendCode(): void;
	setToken(token: string): void;
}

const TokenField = ({ isDisabledSend, sendCode, setToken, token, tokenError }: TokenFieldProps) => {

	const color = {
		font: tokenError.errorStatus ? colors.red[500] : colors.black[500],
		border: tokenError.errorStatus ? colors.red[500] : colors.gray[50],
		borderOnFocus: tokenError.errorStatus ? colors.red[500] : colors.gray[200],
	};

	const handlePaste: React.ClipboardEventHandler = (event) => {
		const data = event.clipboardData.getData("text");

		if (/[^0-9]/.test(data)) {
			return;
		}
		if (data.length > 6) {
			return;
		}

		setToken(data);
	};

	return (
		<OtpInput
			value={token}
			onChange={setToken}
			numInputs={6}
			onPaste={handlePaste}
			inputType='number'
			inputStyle={{ maxWidth: "40px", minWidth: "15px", width: "20%" }}
			renderInput={(props: InputProps & JSX.IntrinsicAttributes & Omit<React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, keyof InputProps> & { as?: "input" | undefined } & { htmlTranslate?: "no" | "yes" | undefined }) =>
				<Input
					height='40px'
					borderTop='none'
					borderRight='none'
					borderLeft='none'
					borderBottomWidth={2}
					borderRadius='0px'
					fontSize='24px'
					fontWeight={500}
					textAlign='center'
					color={color.font}
					borderColor={color.border}
					padding='0'
					margin='0 8.5px'
					_focus={{
						borderLeft: "none",
						borderTop: "none",
						borderRight: "none",
						borderColor: color.borderOnFocus,
					}}
					onKeyUp={(event: React.KeyboardEvent<HTMLInputElement>) => {
						if (isDisabledSend) {
							return;
						}
						if (event.key === "Enter") {
							sendCode();
						}
					}}
					{...props}
				/>
			}
		/>
	);
};

export default TokenField;
